/* -------------------------------------------------------------------------- */
/*                                  Units                                     */
/* -------------------------------------------------------------------------- */

import { UNITS } from '@config/constants/units';

/**
 * Retrieves the label associated with the specified unit ID.
 * @param {string} id - The ID of the unit to retrieve the label for.
 * @returns {string|null} The label of the unit, or null if the unit is not found.
 */
export const getUnitLabel = (id: string) => {
	const foundUnit = UNITS.find((unit) => unit.id === id);
	return foundUnit?.label || '';
};
